import { FunctionComponent } from 'react'

import { useBreakpointValue } from 'native-base'
import { TabPanels, TabPanelsDesktop } from 'organisms'

import { TabCommonProps } from './types'

export const Panels: FunctionComponent<TabCommonProps> = ({
  tabNumber,
  handleGoToFullChartScreen,
  tabDetail,
  tabIsLoading,
  panelsYearMonthFilterOptions,
  panelsSelectedYearMonth,
  onChangePanelsYearMonthFilter
}) => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  if (!tabNumber || !handleGoToFullChartScreen) return null

  if (!isMobile)
    return (
      <TabPanelsDesktop
        tabNumber={tabNumber}
        handleGoToFullChartScreen={handleGoToFullChartScreen}
        opportunity={tabDetail?.opportunity}
        isTabLoading={tabIsLoading}
        yearMonthFilterOptions={panelsYearMonthFilterOptions}
        selectedYearMonth={panelsSelectedYearMonth}
        onChangeYearMonthFilter={onChangePanelsYearMonthFilter}
      />
    )

  return (
    <TabPanels
      tabNumber={tabNumber}
      handleGoToFullChartScreen={handleGoToFullChartScreen}
      opportunity={tabDetail?.opportunity}
      isTabLoading={tabIsLoading}
      yearMonthFilterOptions={panelsYearMonthFilterOptions}
      selectedYearMonth={panelsSelectedYearMonth}
      onChangeYearMonthFilter={onChangePanelsYearMonthFilter}
    />
  )
}
